"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("./styles/_invite-users-notice.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function InviteUsersNotice(_ref) {
  var visible = _ref.visible,
      onClose = _ref.onClose,
      onSave = _ref.onSave;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "invite-users-notice"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.BaseModal, {
    visible: visible,
    onClose: onClose,
    onSave: onSave
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    centered: true,
    heading4: true
  }, "Do you want to add users to this team?"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    className: "invite-users-notice__add-btn",
    small: true,
    onClick: onSave
  }, "Add Users"), /*#__PURE__*/_react.default.createElement(_uiKit.Link, {
    type: "BUTTON",
    className: "invite-users-notice__later-btn",
    onClick: onClose
  }, "Maybe Later")));
}

var _default = (0, _react.memo)(InviteUsersNotice);

exports.default = _default;